import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import NotificationSettingsUpdatedModal from "./modal/NotificationSettingsUpdatedModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import EmailNotification from "./EmailNotification";

export default function Notfications() {
  const [isLoading,setIsLoading] = useState(true)
  const [emailNotification,setEmailNotification] = useState(false)
  const [NotifcationBookingCancellation, setNotifcationBookingCancellation] =
    useState(false);
  const [NotifcationYouHaveUnsubscribed, setNotifcationYouHaveUnsubscribed] =
    useState(false);
  const [
    NotifcationYourRecurringPaymentHasBeenUnsuccessful,
    setNotifcationYourRecurringPaymentHasBeenUnsuccessful,
  ] = useState(false);
  const [
    NotifcationClassBookingConfirmed,
    setNotifcationClassBookingConfirmed,
  ] = useState(false);
  const [
    NotifcationBookingCancellationRequested,
    setNotifcationBookingCancellationRequested,
  ] = useState(false);
  const [NotifcationUsersBoughtTokens, setNotifcationUsersBoughtTokens] =
    useState(false);
  const [
    NotifcationUserSubscribedToYourClub,
    setNotifcationUserSubscribedToYourClub,
  ] = useState(false);
  const [
    NotifcationPaymentForSubscriptionUnsuccessful,
    setNotifcationPaymentForSubscriptionUnsuccessful,
  ] = useState(false);
  const [
    NotifcationUserUnsubscribedFromYourClub,
    setNotifcationUserUnsubscribedFromYourClub,
  ] = useState(false);
  const [NotifcationPaymentResolved, setNotifcationPaymentResolved] =
    useState(false);
  const [
    NotifcationPremiumSubscriptionFailedPayment,
    setNotifcationPremiumSubscriptionFailedPayment,
  ] = useState(false);

  const { user,dispatch } = useAuthContext();
  const navi = useNavigate()
  const [settingsUpdatedModal, setSettingsUpdatedModal] = useState(false);

  const cancelModal = () => {
    setSettingsUpdatedModal(false);
  };

  const handleUpdate = async () => {
    const updateSettings = {
      NotifcationBookingCancellation,
      NotifcationYouHaveUnsubscribed,
      NotifcationYourRecurringPaymentHasBeenUnsuccessful,
      NotifcationClassBookingConfirmed,
      NotifcationBookingCancellationRequested,
      NotifcationUsersBoughtTokens,
      NotifcationUserSubscribedToYourClub,
      NotifcationPaymentForSubscriptionUnsuccessful,
      NotifcationUserUnsubscribedFromYourClub,
      NotifcationPaymentResolved,
      NotifcationPremiumSubscriptionFailedPayment,
    };

    const updateResponse = await axios.put(
      `${ApiConnectionString}/api/NotficationSetting`,
      updateSettings,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );
    if (updateResponse.status == 200) {
      setSettingsUpdatedModal(true);
    }
  };

  const fetchData = async () => {
    setIsLoading(true)
    try{
      const noteSettingsResponse = await axios.get(
        `${ApiConnectionString}/api/NotficationSetting`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (noteSettingsResponse.status === 200) {
        setEmailNotification(noteSettingsResponse.data.emailNotifications)
        setNotifcationBookingCancellation(
          noteSettingsResponse.data.notifcationBookingCancellation
        );
        setNotifcationYouHaveUnsubscribed(
          noteSettingsResponse.data.notifcationYouHaveUnsubscribed
        );
        setNotifcationYourRecurringPaymentHasBeenUnsuccessful(
          noteSettingsResponse.data
            .notifcationYourRecurringPaymentHasBeenUnsuccessful
        );
        setNotifcationClassBookingConfirmed(
          noteSettingsResponse.data.notifcationClassBookingConfirmed
        );
        setNotifcationBookingCancellationRequested(
          noteSettingsResponse.data.notifcationBookingCancellationRequested
        );
        setNotifcationUsersBoughtTokens(
          noteSettingsResponse.data.notifcationUsersBoughtTokens
        );
        setNotifcationUserSubscribedToYourClub(
          noteSettingsResponse.data.notifcationUserSubscribedToYourClub
        );
        setNotifcationPaymentForSubscriptionUnsuccessful(
          noteSettingsResponse.data.notifcationPaymentForSubscriptionUnsuccessful
        );
        setNotifcationUserUnsubscribedFromYourClub(
          noteSettingsResponse.data.notifcationUserUnsubscribedFromYourClub
        );
        setNotifcationPaymentResolved(
          noteSettingsResponse.data.notifcationPaymentResolved
        );
        setNotifcationPremiumSubscriptionFailedPayment(
          noteSettingsResponse.data.notifcationPremiumSubscriptionFailedPayment
        );
      }
    }catch(error){
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
    }finally{
      setIsLoading(false)
    }
  
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case "NotifcationPaymentResolved":
        setNotifcationPaymentResolved(checked);
        break;
      case "NotifcationPremiumSubscriptionFailedPayment":
        setNotifcationPremiumSubscriptionFailedPayment(checked);
        break;
      case "NotifcationBookingCancellation":
        setNotifcationBookingCancellation(checked);
        break;
      case "NotifcationYouHaveUnsubscribed":
        setNotifcationYouHaveUnsubscribed(checked);
        break;
      case "NotifcationYourRecurringPaymentHasBeenUnsuccessful":
        setNotifcationYourRecurringPaymentHasBeenUnsuccessful(checked);
        break;
      case "NotifcationClassBookingConfirmed":
        setNotifcationClassBookingConfirmed(checked);
        break;
      case "NotifcationBookingCancellationRequested":
        setNotifcationBookingCancellationRequested(checked);
        break;
      case "NotifcationUsersBoughtTokens":
        setNotifcationUsersBoughtTokens(checked);
        break;
      case "NotifcationUserSubscribedToYourClub":
        setNotifcationUserSubscribedToYourClub(checked);
        break;
      case "NotifcationPaymentForSubscriptionUnsuccessful":
        setNotifcationPaymentForSubscriptionUnsuccessful(checked);
        break;
      case "NotifcationUserUnsubscribedFromYourClub":
        setNotifcationUserUnsubscribedFromYourClub(checked);
        break;
      default:
        break;
    }
  };

  if(isLoading){
    return(<div>
      <LoadingSpinner />
    </div>)
  }else{

  return (
  <div className="container mt-4">
          <div className='lightBlueBanner mt-2'>
<p className=' fw-bold p-2'>Notifications</p>
      </div>
    <EmailNotification emailNotification={emailNotification} />


    <div className="row mt-3 g-3">
      {/* Customer Notifications */}
      <div className="col-md-6">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="card-title fw-bold">Customer Notifications</h5>

            <div className="form-check mt-3">
              <input className="form-check-input" type="checkbox" name="NotifcationBookingCancellation" checked={NotifcationBookingCancellation} onChange={handleChange} />
              <label className="form-check-label fw-semibold">
                Booking cancellation
              </label>
              <p className="text-muted small mb-0">
                This notification is to inform you that a class you are booked onto has been canceled.
              </p>
            </div>

            <div className="form-check mt-3">
              <input className="form-check-input" type="checkbox" name="NotifcationYouHaveUnsubscribed" checked={NotifcationYouHaveUnsubscribed} onChange={handleChange} />
              <label className="form-check-label fw-semibold">
                You Have Unsubscribed
              </label>
              <p className="text-muted small mb-0">
                This notification informs you that your subscription to a club has been canceled.
              </p>
            </div>

            <div className="form-check mt-3">
              <input className="form-check-input" type="checkbox" name="NotifcationYourRecurringPaymentHasBeenUnsuccessful" checked={NotifcationYourRecurringPaymentHasBeenUnsuccessful} onChange={handleChange} />
              <label className="form-check-label fw-semibold">
                Your recurring payment has been unsuccessful.
              </label>
              <p className="text-muted small mb-0">
                If a recurring payment of yours fails to be collected for any reason, this notification will inform you of the issue.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Club Owner Notifications */}
      <div className="col-md-6">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="card-title fw-bold">Club Owner Notifications</h5>

            {[
              ["NotifcationClassBookingConfirmed", "Class booking confirmed", "This notification will inform you when a customer has booked into one of your classes."],
              ["NotifcationBookingCancellationRequested", "Booking cancellation requested", "This is to notify you when a customer has requested to cancel a booking for one of your classes."],
              ["NotifcationUsersBoughtTokens", "Users bought classes", "This is to notify you when a customer has purchased a bulk of classes for one of your clubs."],
              ["NotifcationUserSubscribedToYourClub", "User subscribed to your club", "This is to notify you when a user has subscribed to recurring payments for one of your clubs."],
              ["NotifcationPaymentForSubscriptionUnsuccessful", "Payment for subscription unsuccessful", "This is to notify you when a customer's recurring payment to your club has failed to be collected."],
              ["NotifcationUserUnsubscribedFromYourClub", "User unsubscribed from your club", "This is to notify you when a user has unsubscribed from your club, ending their recurring payments."],
              ["NotifcationPremiumSubscriptionFailedPayment", "Premium Subscription Failed Payment", "This will notify you if the payment has been unsuccessful for a premium membership of your club."],
              ["NotifcationPaymentResolved", "Payment Resolved", "This will notify you when a customer resolves a payment for their subscription to your club."]
            ].map(([name, label, desc]) => (
              <div key={name} className="form-check mt-3">
                <input className="form-check-input" type="checkbox" name={name} checked={eval(name)} onChange={handleChange} />
                <label className="form-check-label fw-semibold">
                  {label}
                </label>
                <p className="text-muted small mb-0">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div className="my-4 text-center">
      <button className="saveChanges-button" onClick={handleUpdate}>
        Save Settings
      </button>
    </div>

    {settingsUpdatedModal && (
      <NotificationSettingsUpdatedModal cancelModal={cancelModal} />
    )}
  </div>
);

}
}